import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

export default class extends Controller {
  static targets = ["display", "input"]
  static values = {
    url: String,
    model: { type: String, default: "roadmap_column" },
    field: { type: String, default: "name" }
  }

  edit() {
    this.isCancelling = false
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  async save() {
    if (this.isCancelling) return

    const newValue = this.inputTarget.value.trim()
    const oldValue = this.displayTarget.textContent.trim()

    if (!newValue || newValue === oldValue) {
      this.cancel()
      return
    }

    try {
      const body = {}
      body[this.modelValue] = {}
      body[this.modelValue][this.fieldValue] = newValue

      const response = await patch(this.urlValue, {
        body: JSON.stringify(body),
        contentType: "application/json",
        responseKind: "json"
      })

      if (response.ok) {
        this.displayTarget.textContent = newValue
      }
    } catch (error) {
      console.error("Error saving:", error)
    }

    this.cancel()
  }

  cancel() {
    this.isCancelling = true
    this.inputTarget.value = this.displayTarget.textContent.trim()
    this.inputTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      this.cancel()
    }
  }
}
